import { useState } from 'react'
import { playTestTone } from '@/shared/lib'
import { Button } from '@/shared/ui/button'
import { toast } from '@/shared/ui/toast'

// Тон уходит в выбранное устройство вывода (а без выбора — в системное) по
// клику: клик заодно снимает запрет автоплея, поэтому проверка честная —
// слышно тон, слышно и звонок.
export function SpeakerTestButton({ outputId }: { outputId?: string | undefined }) {
  const [playing, setPlaying] = useState(false)

  async function play() {
    setPlaying(true)
    try {
      await playTestTone(outputId)
    } catch {
      toast.error('Не удалось проиграть звук — проверьте устройство вывода в системе')
    } finally {
      setPlaying(false)
    }
  }

  return (
    <Button variant="secondary" size="sm" disabled={playing} onClick={() => void play()}>
      {playing ? 'Звучит…' : 'Проверить звук'}
    </Button>
  )
}
